import LuConcern from './LuConcern'
import User from './User'
import LuPosition from './LuPosition'
import LuPriority from './LuPriority'
import Comment from './Comment'
import Document from './Document'
import Link from './Link'
import TrackedBillAgency from './TrackedBillAgency'
import TrackedBillDivision from './TrackedBillDivision'
import TrackedBillAssignment from './TrackedBillAssignment'
import TrackedBillUser from './TrackedBillUser'
export default class TrackedBill {
  constructor(objIn = {}) {
    const defaults = {
      //ID is required
      ID: 0,
      //BillNumber is required
      BillNumber: '',
      //Year is required
      Year: 0,
      SpecialSession: null,
      ShortTitle: null,
      BillType: null,
      Sponsor: null,
      Synopsis: null,
      Pros: null,
      Cons: null,
      ProposedChanges: null,
      Contact: null,
      //IsPrivate is required
      IsPrivate: false,
      ConcernID: null,
      PriorityID: null,
      CreatedByID: null,
      IsActive: true,
      CreatedDate: null,
      UpdatedDate: null,
      UpdatedByID: null,
      PositionID: null,
      LsoBillStatus: null,
      LsoLastAction: null,
      LsoLastActionDate: null,
      LsoUpdatedDate: null,
    }
    let obj = {}
    Object.assign(obj, defaults, objIn)
    this.ID = obj.ID
    this.BillNumber = obj.BillNumber
    this.Year = obj.Year
    this.SpecialSession = obj.SpecialSession
    this.ShortTitle = obj.ShortTitle
    this.BillType = obj.BillType
    this.Sponsor = obj.Sponsor
    this.Synopsis = obj.Synopsis
    this.Pros = obj.Pros
    this.Cons = obj.Cons
    this.ProposedChanges = obj.ProposedChanges
    this.Contact = obj.Contact
    this.IsPrivate = obj.IsPrivate
    this.ConcernID = obj.ConcernID
    this.PriorityID = obj.PriorityID
    this.CreatedByID = obj.CreatedByID
    this.IsActive = obj.IsActive
    this.CreatedDate = obj.CreatedDate
    this.UpdatedDate = obj.UpdatedDate
    this.UpdatedByID = obj.UpdatedByID
    this.PositionID = obj.PositionID
    this.LsoBillStatus = obj.LsoBillStatus
    this.LsoLastAction = obj.LsoLastAction
    this.LsoLastActionDate = obj.LsoLastActionDate
    this.LsoUpdatedDate = obj.LsoUpdatedDate
    this.Concern = new LuConcern(obj.Concern || {})
    this.CreatedBy = new User(obj.CreatedBy || {})
    this.Position = new LuPosition(obj.Position || {})
    this.Priority = new LuPriority(obj.Priority || {})
    this.UpdatedBy = new User(obj.UpdatedBy || {})

    this.Comments = []
    if (obj.Comments) {
      obj.Comments.forEach((item) => {
        this.Comments.push(new Comment(item))
      })
    }
    this.Documents = []
    if (obj.Documents) {
      obj.Documents.forEach((item) => {
        this.Documents.push(new Document(item))
      })
    }
    this.Links = []
    if (obj.Links) {
      obj.Links.forEach((item) => {
        this.Links.push(new Link(item))
      })
    }
    this.TrackedBillAgencies = []
    if (obj.TrackedBillAgencies) {
      obj.TrackedBillAgencies.forEach((item) => {
        this.TrackedBillAgencies.push(new TrackedBillAgency(item))
      })
    }
    this.TrackedBillDivisions = []
    if (obj.TrackedBillDivisions) {
      obj.TrackedBillDivisions.forEach((item) => {
        this.TrackedBillDivisions.push(new TrackedBillDivision(item))
      })
    }
    this.TrackedBillAssignments = []
    if (obj.TrackedBillAssignments) {
      obj.TrackedBillAssignments.forEach((item) => {
        this.TrackedBillAssignments.push(new TrackedBillAssignment(item))
      })
    }
    this.TrackedBillUsers = []
    if (obj.TrackedBillUsers) {
      obj.TrackedBillUsers.forEach((item) => {
        this.TrackedBillUsers.push(new TrackedBillUser(item))
      })
    }
  }
  removeRelated() {
    let obj = Object.assign({}, this)
    obj.Concern = null
    obj.CreatedBy = null
    obj.Position = null
    obj.Priority = null
    obj.UpdatedBy = null
    obj.Comments = []
    if (this.Comments) {
      this.Comments.forEach((item) => {
        obj.Comments.push(item.removeRelated())
      })
    }
    obj.Documents = []
    if (this.Documents) {
      this.Documents.forEach((item) => {
        obj.Documents.push(item.removeRelated())
      })
    }
    obj.Links = []
    if (this.Links) {
      this.Links.forEach((item) => {
        obj.Links.push(item.removeRelated())
      })
    }
    obj.TrackedBillAgencies = []
    if (this.TrackedBillAgencies) {
      this.TrackedBillAgencies.forEach((item) => {
        obj.TrackedBillAgencies.push(item.removeRelated())
      })
    }
    obj.TrackedBillDivisions = []
    if (this.TrackedBillDivisions) {
      this.TrackedBillDivisions.forEach((item) => {
        obj.TrackedBillDivisions.push(
          item instanceof TrackedBillDivision ? item.removeRelated() : item
        )
      })
    }
    obj.TrackedBillAssignments = []
    if (this.TrackedBillAssignments) {
      this.TrackedBillAssignments.forEach((item) => {
        obj.TrackedBillAssignments.push(item.removeRelated())
      })
    }
    obj.TrackedBillUsers = []
    if (this.TrackedBillUsers) {
      this.TrackedBillUsers.forEach((item) => {
        obj.TrackedBillUsers.push(item.removeRelated())
      })
    }
    return obj
  }
  getSaveData() {
    let obj = Object.assign({}, this)
    obj.Concern = null
    obj.CreatedBy = null
    obj.Position = null
    obj.Priority = null
    obj.UpdatedBy = null
    obj.Comments = null
    obj.Documents = null
    obj.Links = null
    obj.TrackedBillAgencies = []
    if (this.TrackedBillAgencies) {
      this.TrackedBillAgencies.forEach((item) => {
        obj.TrackedBillAgencies.push(item.removeRelated())
      })
    }
    obj.TrackedBillDivisions = []
    if (this.TrackedBillDivisions) {
      this.TrackedBillDivisions.forEach((item) => {
        obj.TrackedBillDivisions.push(
          item instanceof TrackedBillDivision ? item.removeRelated() : item
        )
      })
    }
    obj.TrackedBillAssignments = []
    if (this.TrackedBillAssignments) {
      this.TrackedBillAssignments.forEach((item) => {
        obj.TrackedBillAssignments.push(item.removeRelated())
      })
    }
    obj.TrackedBillUsers = []
    return obj
  }
  root() {
    let obj = Object.assign({}, this)
    obj.Concern = null
    obj.CreatedBy = null
    obj.Priority = null
    obj.UpdatedBy = null
    obj.Comments = null
    obj.Documents = null
    obj.Links = null
    obj.TrackedBillAgencies = null
    obj.TrackedBillAssignments = null
    obj.TrackedBillUsers = null
    return obj
  }
}
